var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetInvolvedinline = function SvgGetInvolvedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 22,
    fill: "#EB4748",
    rx: 2,
    transform: "rotate(-90 2 22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M17 15.167a2.1 2.1 0 0 0-.196-.9 1.43 1.43 0 0 0-.53-.615c-1.348-.781-2.805-1.174-4.274-1.151-1.47-.023-2.926.37-4.273 1.151a1.43 1.43 0 0 0-.531.615 2.1 2.1 0 0 0-.196.9V17a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5z"
  })));
};
export default SvgGetInvolvedinline;